import React, { useEffect, useState } from "react";

const MachineManagement = () => {
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    refreshMachine();
  }, []);

  const refreshMachine = async () => {
    try {
      const response = await fetch("/api/machine");
      const data = await response.json();
      setMachines(data);
    } catch (error) {
      console.error("Error fetching machines:", error);
    }
  };

  const [newMachine, setNewMachine] = useState({
    name_en: "",
    name_fr: "",
    name_de: "",
    name_it: "",
    name_es: "",
    description_en: "",
    description_fr: "",
    description_de: "",
    description_it: "",
    description_es: "",
    metadescription_en: "",
    metadescription_fr: "",
    metadescription_de: "",
    metadescription_it: "",
    metadescription_es: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewMachine({
      ...newMachine,
      [name]: value,
    });
  };

  const handleAddMachine = async () => {
    try {
      const response = await fetch("/api/machine", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newMachine),
      });
      if (response.ok) {
        refreshMachine();
        setNewMachine({
          name_en: "",
          name_fr: "",
          name_de: "",
          name_it: "",
          name_es: "",
          description_en: "",
          description_fr: "",
          description_de: "",
          description_it: "",
          description_es: "",
          metadescription_en: "",
          metadescription_fr: "",
          metadescription_de: "",
          metadescription_it: "",
          metadescription_es: "",
        });
      } else {
        console.error("Error adding machine:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding machine:", error);
    }
  };

  return (
    <div>
      <button
        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mb-4"
        type="button"
        onClick={() => (window.location.href = "/admin/dashboard")}
      >
        Go Back
      </button>
      <table className="min-w-full divide-y divide-black">
        <thead>
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
              Name
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
              Categories
            </th>
          </tr>
        </thead>
        <tbody id="machine-container" className="divide-y divide-black">
          {machines.map((machine) => (
            <tr
              key={machine.id}
              onClick={() =>
                (window.location.href = `/admin/machine/${machine.id}`)
              }
              className="hover:bg-gray-950 cursor-pointer"
            >
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-white">
                {machine.name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                {machine.categories.map((category) => category.name).join(", ")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-4">
        <input
          type="text"
          name="name_en"
          value={newMachine.name_en}
          onChange={handleInputChange}
          placeholder="Name (English)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="name_fr"
          value={newMachine.name_fr}
          onChange={handleInputChange}
          placeholder="Name (French)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="name_de"
          value={newMachine.name_de}
          onChange={handleInputChange}
          placeholder="Name (German)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="name_it"
          value={newMachine.name_it}
          onChange={handleInputChange}
          placeholder="Name (Italian)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="name_es"
          value={newMachine.name_es}
          onChange={handleInputChange}
          placeholder="Name (Spanish)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="description_en"
          value={newMachine.description_en}
          onChange={handleInputChange}
          placeholder="Description (English)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="description_fr"
          value={newMachine.description_fr}
          onChange={handleInputChange}
          placeholder="Description (French)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="description_de"
          value={newMachine.description_de}
          onChange={handleInputChange}
          placeholder="Description (German)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="description_it"
          value={newMachine.description_it}
          onChange={handleInputChange}
          placeholder="Description (Italian)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="description_es"
          value={newMachine.description_es}
          onChange={handleInputChange}
          placeholder="Description (Spanish)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="metadescription_en"
          value={newMachine.metadescription_en}
          onChange={handleInputChange}
          placeholder="Meta Description (English)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="metadescription_fr"
          value={newMachine.metadescription_fr}
          onChange={handleInputChange}
          placeholder="Meta Description (French)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="metadescription_de"
          value={newMachine.metadescription_de}
          onChange={handleInputChange}
          placeholder="Meta Description (German)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="metadescription_it"
          value={newMachine.metadescription_it}
          onChange={handleInputChange}
          placeholder="Meta Description (Italian)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <input
          type="text"
          name="metadescription_es"
          value={newMachine.metadescription_es}
          onChange={handleInputChange}
          placeholder="Meta Description (Spanish)"
          className="mb-2 p-2 border border-gray-300 rounded text-gray-900"
        />
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          onClick={handleAddMachine}
        >
          Add New Machine
        </button>
      </div>
    </div>
  );
};

export default MachineManagement;
